import { i18n } from '@shared/i18n';
import { UserField } from '@modules/auth/user-field';
import DateRangeField from '@shared/fields/date-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import IdField from '@shared/fields/id-field';
import StringArrayField from '@shared/fields/string-array-field';
import StringField from '@shared/fields/string-field';
import { GenericModel } from '@shared/model/generic-model';
import * as yup from 'yup';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

// import { PriceField } from '@modules/price/price-field';

function label(name) {
  return i18n(`entities.program.fields.${name}`);
}

class EmailsField extends StringArrayField {
  forFormRules() {
    let yupValidator = yup
      .array()
      .label(this.label)
      .of(
        yup
          .string()
          .email(i18n('user.validations.email'))
          .label(i18n('user.fields.email'))
          .max(255)
          .required(),
      );

    if (this.required) {
      yupValidator = yupValidator.required();
    }

    const validator = (rule, value, callback) => {
      try {
        yupValidator.validateSync(value);
        callback();
      } catch (error) {
        callback(error);
      }
    };

    return [{ validator }];
  }
}

const fields = {
  id: new IdField('id', label('id')),

  name: new StringField('name', label('name'), {
    "required": true
  }),
  
  sport: new EnumeratorField('sport', label('sport'), getSharedEnumeratorField('sport'), { required: true }),
  
  subprograms: new StringField('subprograms', label('subprograms'), {}),
  
  type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('programType'), { required: true }),

  emails: new EmailsField('emails', label('emails'), {}),

  managers: UserField.relationToMany('managers', label('managers'), {}),

  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('programStatus'), {required: true}),

  access: new EnumeratorField('access', label('access'), getSharedEnumeratorField('access'), { "required": true }),
  
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
    { format: i18n('common.date.format') },
  ),
  startDateRange: new DateRangeField(
    'startDateRange',
    label('startDateRange'),
    { format: i18n('common.date.format') },
  ),
  endDateRange: new DateRangeField(
    'endDateRange',
    label('endDateRange'),
    { format: i18n('common.date.format') },
  ),
  regStartDateRange: new DateRangeField(
    'regStartDateRange',
    label('regStartDateRange'),
    { format: i18n('common.date.format') },
  ),
  regEndDateRange: new DateRangeField(
    'regEndDateRange',
    label('regEndDateRange'),
    { format: i18n('common.date.format') },
  )

  
};

export class ProgramModel extends GenericModel {
  static get fields() {
    return fields;
  }

}
